import Vue from 'vue';
import VueResource from 'vue-resource';

import App from './App';
import router from './router';
import store from './store/store';
import './vendor';
import './config/fundebug.config';
import './config/sensors-data.config';
import Print from './libs/print';
import './libs/filter';

import 'viewerjs/dist/viewer.css';
import VueViewer from 'v-viewer';
// 监听是否出现在屏幕中
import VueObserveVisibility from 'vue-observe-visibility';


// service
import service from './services/index';

Vue.use(VueViewer, {
  defaultOptions: {
    zIndex: 3000,
  },
});

Vue.use(VueResource);

Vue.use(service);

Vue.use(Print);

Vue.use(VueObserveVisibility);


// 初始化qrcode
store.commit('followOA/INIT_QRCODE');

// 初始化qrcodeSHow和closeDate
store.commit('followOA/INIT_QRCODE_STA');

Vue.config.productionTip = false;

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  // render: h => h(App),
  render(createElement) {
    return createElement(App);
  },
});



// WEBPACK FOOTER //
// ./src/main.js